<pane-card >
  
  <card-content ngProjectAs="card-main-content">

      <div class="h-100 user-card p-3 d-flex flex-column rounded-1">
          <div>
              <avatar-upload [currentUser]="currentUser()"></avatar-upload>
              <user-details [currentUser]="currentUser()"></user-details>
              
              <h4 ngProjectAs="caption" class="tenant-selector-title">Tenants</h4>
              <tenant-picker-list></tenant-picker-list>

              <button type="button" style="margin-top: 50px;" class="btn btn-outline-danger btn-sm w-100 text-start" (click)="logout()">
                Sign out
              </button>
          </div>
      </div>

  </card-content>

</pane-card>
